import { ReferentialKey } from 'api/referential';
import { ComponentKey } from 'enums/componentKey';
import { LegalEntityFormFieldNames } from 'features/new-actor/enums/legalEntityFormFieldNames';
import { PersonalInformationFieldNames } from 'features/new-actor/enums/personalInformationFieldNames';
import { LegalEntityContactFormValues } from 'features/new-actor/types/legalEntityContactFormValues';
import { InputConfig } from 'types/form/componentConfig';
import { InputsConfig } from 'types/form/inputsConfig';
import { addressInputsConfig } from '../addressInputsConfig';
import { personalInformationInputsConfig } from '../personalInformationInputsConfig';


type LegalEntityInputsConfig = InputsConfig<Exclude<keyof LegalEntityContactFormValues, 'id'>>

// Contact d'une PM (ex. gérant) : la personne peut déjà exister en base avec le
// même téléphone/email — pas de contrôle d'unicité, contrairement à la création
// d'un acteur autonome.
const { existenceCheck: _phoneCheck, ...contactPhoneConfig } =
  personalInformationInputsConfig[PersonalInformationFieldNames.Phone] as InputConfig;
const { existenceCheck: _emailCheck, ...contactEmailConfig } =
  personalInformationInputsConfig[PersonalInformationFieldNames.Email] as InputConfig;

export const legalEntityContactInputsConfig: LegalEntityInputsConfig = {
  ...personalInformationInputsConfig,
  ...addressInputsConfig,
  [PersonalInformationFieldNames.Phone]: contactPhoneConfig,
  [PersonalInformationFieldNames.Email]: contactEmailConfig,
  [LegalEntityFormFieldNames.CompanyRole]: {
    componentKey: ComponentKey.ReferentialDropdown,
    referentialKey: ReferentialKey.CompanyRole,
    name: LegalEntityFormFieldNames.CompanyRole,
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.LABELS.COMPANY_ROLE',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.PLACEHOLDERS.COMPANY_ROLE'
  },
};
